"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = buildResponsiveSize;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// import { gridConfig as breakpoints } from '@tvg/fuse-design';

function buildResponsiveSize(size) {
  var breakpoints = {
    xxs: {
      gutter: '0.8rem',
      margin: '1.6rem',
      maxWidth: "".concat(35.9 * 0.625, "rem"),
      minWidth: '0rem'
    },
    xs: {
      gutter: '0.8rem',
      margin: '1.6rem',
      maxWidth: "".concat(37.4 * 0.625, "rem"),
      minWidth: "".concat(36 * 0.625, "rem")
    },
    s: {
      gutter: '0.8rem',
      margin: '1.6rem',
      maxWidth: "".concat(76.7 * 0.625, "rem"),
      minWidth: "".concat(37.5 * 0.625, "rem")
    },
    m: {
      gutter: '1.2rem',
      margin: '2.4rem',
      maxWidth: "".concat(102.3 * 0.625, "rem"),
      minWidth: "".concat(76.8 * 0.625, "rem")
    },
    l: {
      gutter: '1.2rem',
      margin: '2.4rem',
      maxWidth: "".concat(143.9 * 0.625, "rem"),
      minWidth: "".concat(102.4 * 0.625, "rem")
    },
    xl: {
      gutter: '1.6rem',
      margin: '8rem',
      maxWidth: "".concat(191.9 * 0.625, "rem"),
      minWidth: "".concat(144 * 0.625, "rem")
    },
    xxl: {
      gutter: '1.6rem',
      margin: '8rem',
      maxWidth: '',
      minWidth: "".concat(192 * 0.625, "rem")
    }
  };
  // Array of breakpoints i.e. xxs, xs, s, m, l, xl, xxl
  var breakpointsList = Object.keys(breakpoints);

  // Array of valid viewports from size prop passed
  var viewports = _typeof(size) === 'object' && Object.keys(size).filter(function (item) {
    return breakpointsList.includes(item);
  });

  // Check if size prop passed is responsive based on viewports above
  var isResponsive = (viewports === null || viewports === void 0 ? void 0 : viewports.length) > 0;

  // Function to set CSS based on array of viewports
  var setViewportCss = function setViewportCss(cssForViewport) {
    if (!(viewports !== null && viewports !== void 0 && viewports.length)) {
      return '';
    }
    return viewports.reduce(function (acc, viewport) {
      var viewportSize = size[viewport];
      var viewportCss = "\n\t\t\t@media screen and (min-width: ".concat(breakpoints[viewport].minWidth, ") {\n\t\t\t\t").concat(cssForViewport(viewportSize), "\n\t\t\t}");
      return acc + viewportCss;
    }, '');
  };
  return [isResponsive, setViewportCss];
}